module.exports = __webpack_public_path__ + "assets/img/submitBtn.59d0d47d.png";